// @flow
import { httpGet, httpPost } from '~/core/api/helpers/helpers.api';
import url from 'url';

export function getProducts(after: Date): Promise<Response> {
    const getProductsURL = url.format({
        pathname: 'products',
        query: {
            after
        }
    });

    return httpGet(getProductsURL);
}

export function patchProduct(patch: Object, productType: string, id: string): Promise<Response> {
    const patchProductsURL = url.format({
        pathname: `nodes/${productType}/${id}`
    });

    return httpPost(patchProductsURL, patch);
}

export function restartHub(id: string): Promise<Response> {
    const restartHubURL = url.format({
        pathname: `nodes/hub/${id}`
    });

    return httpPost(restartHubURL, { reboot: true });
}



// WEBPACK FOOTER //
// ./src/core/api/products/products.api.js